<div class="viewed-card">
  <mat-icon
    (click)="closeCardViewing.emit()"
    class="close-icon"
    aria-hidden="false"
    aria-label="close icon"
    iconPositionEnd
    >close</mat-icon
  >

  <h3 class="viewed-card__heading">{{ cardOnViewing.Name }}</h3>

  <p class="viewed-card__subheading">{{ getAddress() }}</p>

  <ng-content select="[mapContainer]"></ng-content>

  <div class="viewed-card__details">
    <div class="details__group">
      <h4 class="group__title">{{ cardOnViewing.Name }}</h4>
      <span class="group__label">Location Name</span>
    </div>

    <div class="details__group">
      <h4 class="group__title">
        {{ cardOnViewing.LocationTypeId | locationTypePipe }}
      </h4>
      <span class="group__label">Location Type</span>
    </div>

    <div class="details__group">
      <h4 class="group__title">{{ cardOnViewing.AddressDetails }}</h4>
      <span class="group__label">Additional Details</span>
    </div>
  </div>

  <div class="photos">
    <img
      class="photos__photo"
      [src]="cardOnViewing.ImageUrl"
      [alt]="'Photo of ' + cardOnViewing.ImageUrl"
    />
    <span class="photos__label">Location Photos</span>
  </div>

  <div class="button-container">
    <button
      mat-button
      class="button-container__edit-button"
      (click)="editStore.emit(cardOnViewing)"
    >
      Edit
    </button>
  </div>
</div>
